export const getUserToken = () => {
  let token = JSON.parse(localStorage.getItem("token"));

  if (!token) throw new Error("No token found!");

  return token.access_token;
};

export const getAuthHeaders = () => {
  const token = getUserToken();

  return {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
};
